import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";


class CampagnePhysiqueService {
  //Afficher List CampagnePhysiques
  AfficherListCampagnePhysiques(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/getAll/" + idUser);
  }

  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/getTypes/" + idUser);
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/getCanalDiffusions/" + idUser);
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/getStatus/");
  }

  // Obtenir la liste des ID de photos dans une CampagnePhysique
  getCampagnePhysiquePhotosId(id) {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/ListImages/"+getCurrentUserId()+"/"+ id);
  }

  // Afficher une image par son ID
  showImage(imageId) {
    return api
      .get(UtilsUrl.marketingURL() + "/campagnePhysique/showImage/" + imageId, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const arrayBufferView = new Uint8Array(response.data);
        const blob = new Blob([arrayBufferView], {
          type: response.headers["content-type"],
        });
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;
      });
  }

  //ajouter CampagnePhysique
  ajouterCampagnePhysique(nouvelleCampagnePhysique, images) {
    console.log("nouvelleCampagnePhysique", nouvelleCampagnePhysique)
    console.log("images", images)

    const formData = new FormData();
    formData.append(
      "campagnePhysique",
      JSON.stringify(nouvelleCampagnePhysique)
    );
    let idUser= getCurrentUserId();
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.post(UtilsUrl.marketingURL() + "/campagnePhysique/Add/"+idUser, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
  }

  //mettreAJour CampagnePhysique
  mettreAJourCampagnePhysique(
    updatedCampagnePhysique,
    images,
    CampagnePhysiqueId
  ) {
    const formData = new FormData();
    formData.append(
      "campagnePhysique",
      JSON.stringify(updatedCampagnePhysique)
    );
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.put(
      UtilsUrl.marketingURL() + "/campagnePhysique/update/" + CampagnePhysiqueId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }
  //supprimer CampagnePhysique
  supprimerCampagnePhysique(CampagnePhysiqueId) {
    return api.put(UtilsUrl.marketingURL() + "/campagnePhysique/delete/"+getCurrentUserId()+"/"  + CampagnePhysiqueId);
  }

  //get CampagnePhysique By ID
  getCampagnePhysiqueByID(CampagnePhysiqueId) {
    return api.get(UtilsUrl.marketingURL() + "/campagnePhysique/get/"+getCurrentUserId()+"/" + CampagnePhysiqueId);
  }

  //filtre
  getCampagnePhysiquesByFiltre(nom, statut, startDate, endDate) {
    // return api.get(
    //   UtilsUrl.marketingURL() +
    //   "/filtre?nom=" +
    //   nom +
    //   "&statut=" +
    //   statut +
    //   "&startDate=" +
    //   startDate +
    //   "&endDate=" +
    //   endDate
    // );
  }

  //CSV Methodes
  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/importcsv", file);
  }

  Exportcsv(nom, canalDiffusion, type, startDate, endDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/exportcsv?nom=" +
      nom +
      "&type=" +
      type +
      "&canalDiffusion=" +
      canalDiffusion +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate,
      {
        responseType: "blob",
      }
    );
  }
}

export default new CampagnePhysiqueService();
